import { useEventCallback } from "usehooks-ts";
import { Button, type ButtonProps } from "@/components/Button";

type FileInputBtnProps = Omit<ButtonProps, "onClick" | "onChange"> & {
  onChange?: (files: FileList) => unknown;
  multiple?: boolean;
  accept?: string[];
};

export function FileInputBtn(props: FileInputBtnProps) {
  const { onChange, multiple, ...rest } = props;
  const handleClick = useEventCallback(() => {
    const input = document.createElement("input");
    input.type = "file";
    if (props.multiple) {
      input.multiple = true;
    }

    if (props.accept !== undefined) {
      input.accept = props.accept.join(",");
    }

    input.onchange = (e) => {
      const target = e.target as HTMLInputElement;
      if (target.files && props.onChange) {
        props.onChange(target.files);
      }

      // cleanup
      input.remove();
    };
    input.oncancel = () => input.remove();

    input.click();
  });

  return <Button {...rest} onClick={handleClick} />;
}
